// src/views/accueil/_tons.js — LES VALEURS DE LA MAQUETTE, TELLES QUELLES.
//
// ⚠️ LA MAQUETTE FAIT FOI (§ du cadrage). Ces hex sont recopiés d'elle, pas
// dérivés du DS admin — et ils en DIFFÈRENT sur deux points, signalés à
// Dimitri plutôt que silencieusement alignés :
//   · le terracotta de la maquette est #b8412b ; celui du DS est #D85A30 ;
//   · l'ambre de la maquette est #d4a24c ; celui du DS est #EF9F27.
// Aligner d'autorité aurait changé le rendu qu'il a validé à l'écran ; la
// règle « validation écran par écran » interdit de trancher seul. Un seul
// endroit à corriger le jour où il tranche.

export const TERRA = '#b8412b'
export const TERRA_BG = '#fdf4f0'
export const TERRA_TX = '#8f2f1d'
export const TERRA_BD = '#e0b5a5'
export const AMBRE = '#d4a24c'
export const AMBRE_BG = '#fdf7ee'
export const AMBRE_TX = '#8a5f19'
export const AMBRE_BD = '#e8d4b0'
export const VERT = '#7fc4a3'
export const CIEL_P = '#e8f2fa'
export const NAVY = '#3d5166'
export const NAVY_D = '#233240'
export const GRIS = '#5c6773'
export const GRIS_D = '#98a2ad'
export const BORD = '#e3e8ee'

/** [fond, bordure, plein, texteSurPlein, titre] — l'ordre de la maquette. */
export const TONS = Object.freeze({
  terra: [ '#f7ddd4', '#d19782', TERRA, '#fff', TERRA_TX ],
  ambre: [ '#faeacb', '#cfa758', AMBRE, '#fff', AMBRE_TX ],
  ciel:  [ '#d6e8f7', '#8fb6d6', NAVY,  '#fff', NAVY_D ],
  gris:  [ '#eaeff4', '#c3cdd6', GRIS,  '#fff', '#3d4a57' ],
  vert:  [ '#d7ece1', '#9ccbb2', '#4a9d7a', '#fff', '#124a33' ],
})

/** La pastille d'une ligne de détail, par ton (dans le bandeau). */
export const PASTILLE_DETAIL = Object.freeze({
  vert:  { background: VERT,  color: '#fff' },
  terra: { background: TERRA, color: '#fff' },
  ambre: { background: AMBRE, color: '#fff' },
  ciel:  { background: '#87b8e6', color: '#fff' },
})
